// extracted by mini-css-extract-plugin
module.exports = {"cls1":"CinePlayer-CssProp3_div-module--cls1--1C7w4","cls2":"CinePlayer-CssProp3_div-module--cls2--c_nKZ CinePlayer-CssProp3_div-module--cls1--1C7w4"};